import React from "react";
import { Flex, Heading } from "theme-ui";
import PropTypes from "prop-types";
import { typography, colors, AuthorHeaderSection } from "@greythr/shared-components";
import ShareSection from "./ShareSection";

const Header = ({
  title,
  subTitle,
  customStyles,
  url,
  imageSrc,
  description,
  authors,
  timeToRead,
  publishDate,
  updatedDate,
}) => {
  return (
    <Flex>
      <Flex sx={{ gap: "1.5rem", flexDirection: "column", ...customStyles }}>
        <Heading
          as="h1"
          sx={{
            ...typography.h1,
          }}
        >
          {title}
        </Heading>
        <Heading as="h3" sx={{ ...typography.h3, color: colors.neutral600 }}>
          {subTitle}
        </Heading>
        <AuthorHeaderSection
          authors={authors}
          publishDate={publishDate}
          updatedDate={updatedDate}
          timeToRead={timeToRead}
        />
        <ShareSection
          imageSrc={imageSrc}
          url={url}
          description={description}
          title={title}
        />
      </Flex>
    </Flex>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  sx: PropTypes.object,
  url: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  description: PropTypes.string,
};

Header.defaultProps = {
  title: "title",
  subTitle: "subTitle",
  sx: {},
  url: "url here",
  imageSrc: "image url here",
  description: "",
};

export default Header;
